import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { PadlockService } from "../../padlock/padlock.service";
import { PadlockTokenState } from "../../padlock/state/padlock-token.reducer";
import { selectPadlockTokenState } from "../../padlock/state/padlock-token.selectors";
import { SideNavState } from "../../side-nav/state/side-nav/side-nav.reducer";
import { selectSideNavState } from "../../side-nav/state/side-nav/side-nav.selectors";
import { Workspace } from "../state/workspaces.model";
import { selectActiveWorkspace } from "../state/workspaces.selectors";
import { WorkspaceRoutes } from "../workspace.routes";

@Component({
  selector: "app-workspace-nav",
  templateUrl: "./workspace-nav.component.html",
  styleUrls: ["./workspace-nav.component.scss"],
  standalone: false,
})
export class WorkspaceNavComponent implements OnInit, OnDestroy {
  WORKSPACE_ROUTES = WorkspaceRoutes;

  sideNav$: Observable<SideNavState> = this.store.select(selectSideNavState);
  workspace$ = this.store.select(selectActiveWorkspace);
  workspace_: Subscription;
  workspace: Workspace;

  // Routes are dynamic
  SOURCES: string[] = [this.WORKSPACE_ROUTES.ROOT];
  SETTINGS: string[] = [this.WORKSPACE_ROUTES.ROOT];
  MEMBERS: string[] = [this.WORKSPACE_ROUTES.ROOT];
  CATEGORY: string[] = [this.WORKSPACE_ROUTES.CATEGORY_ROOT];
  CATEGORY_PUNCHES: string[] = [this.WORKSPACE_ROUTES.CATEGORY_PUNCHES];
  SENTIMENT: string[] = [this.WORKSPACE_ROUTES.SENTIMENT_ROOT];
  CHATS: string[] = [this.WORKSPACE_ROUTES.ROOT];
  API_USAGE_ANALYTICS: string[] = [this.WORKSPACE_ROUTES.API_USAGE_ANALYTICS];
  API_CATEGORY_ANALYTICS: string[] = [
    this.WORKSPACE_ROUTES.API_CATEGORY_ANALYTICS,
  ];
  REPORTS: string[] = [this.WORKSPACE_ROUTES.REPORTS];
  RECOMPARE: string[] = [this.WORKSPACE_ROUTES.RECOMPARE];
  DOWNLOADS: string[] = [this.WORKSPACE_ROUTES.DOWNLOADS];
  PIPELINE_PROGRESS: string[] = [this.WORKSPACE_ROUTES.PIPELINE_PROGRESS];

  constructor(public store: Store<any>) {}

  ngOnInit() {
    this.workspace_ = this.workspace$.subscribe((ws) =>
      ws ? this.onWorkspaceStateChange(ws) : null,
    );
  }

  ngOnDestroy() {
    this.workspace_.unsubscribe();
  }

  onWorkspaceStateChange(workspace: Workspace) {
    this.workspace = workspace;

    this.SOURCES = [this.WORKSPACE_ROUTES.ROOT];
    this.SETTINGS = [this.WORKSPACE_ROUTES.ROOT];

    // If there is an activated workspace, splice in the name
    if (workspace) {
      this.SOURCES = ["./", workspace.name, this.WORKSPACE_ROUTES.SURVEY_ROOT];
      this.SETTINGS = ["./", workspace.name, this.WORKSPACE_ROUTES.SETTINGS];
      this.MEMBERS = ["./", workspace.name, this.WORKSPACE_ROUTES.MEMBERS];
      this.CHATS = ["./", workspace.name, this.WORKSPACE_ROUTES.CHAT_ROOT];
      this.CATEGORY = [
        "./",
        workspace.name,
        this.WORKSPACE_ROUTES.CATEGORY_ROOT,
      ];
      this.CATEGORY_PUNCHES = [
        "./",
        workspace.name,
        this.WORKSPACE_ROUTES.CATEGORY_PUNCHES,
      ];
      this.SENTIMENT = [
        "./",
        workspace.name,
        this.WORKSPACE_ROUTES.SENTIMENT_ROOT,
      ];
      this.API_USAGE_ANALYTICS = [
        "./",
        workspace.name,
        this.WORKSPACE_ROUTES.API_USAGE_ANALYTICS,
      ];
      this.API_CATEGORY_ANALYTICS = [
        "./",
        workspace.name,
        this.WORKSPACE_ROUTES.API_CATEGORY_ANALYTICS,
      ];
      this.REPORTS = ["./", workspace.name, this.WORKSPACE_ROUTES.REPORTS];
      this.RECOMPARE = ["./", workspace.name, this.WORKSPACE_ROUTES.RECOMPARE];
      this.DOWNLOADS = ["./", workspace.name, this.WORKSPACE_ROUTES.DOWNLOADS];
      this.PIPELINE_PROGRESS = [
        "./",
        workspace.name,
        this.WORKSPACE_ROUTES.PIPELINE_PROGRESS,
      ];
    }
  }
}
